export function buildCharacterCampaignPreview(character = {}) {
  const classes = Array.isArray(character?.classes) ? character.classes : []
  const classLabel =
    String(character?.class || '').trim() ||
    classes
      .map((entry) => {
        const name = String(entry?.name || '').trim()
        const level = Number(entry?.level)
        if (!name) return ''
        return level > 0 ? `${name} ${level}` : name
      })
      .filter(Boolean)
      .join('/')

  const directLevel = Number(character?.level)
  const classLevel = classes.reduce((sum, entry) => {
    const level = Number(entry?.level)
    return sum + (level > 0 ? level : 0)
  }, 0)

  return {
    name: String(character?.name || '').trim() || 'Unnamed Character',
    avatar: character?.avatar || character?.thumbnail || null,
    race: String(character?.race || '').trim() || null,
    class: classLabel || null,
    level: directLevel > 0 ? directLevel : classLevel > 0 ? classLevel : null
  }
}

export function formatCharacterCampaignSummary(character = {}) {
  const race = String(character?.race || '').trim()
  const classLabel = String(character?.class || '').trim()
  const level = Number(character?.level)

  const parts = [race, classLabel].filter(Boolean)
  let summary = parts.join(' ')

  if (level > 0) {
    summary = summary ? `${summary} (Level ${level})` : `(Level ${level})`
  }

  return summary
}

export function resolveCharacterCampaignIds(character = {}) {
  return Array.from(
    new Set(
      [
        character?.campaignId,
        ...(Array.isArray(character?.campaignIds) ? character.campaignIds : []),
        character?.frontmatter?.campaignId,
        ...(Array.isArray(character?.frontmatter?.campaignIds) ? character.frontmatter.campaignIds : [])
      ]
        .map((value) => String(value || '').trim())
        .filter(Boolean)
    )
  )
}

export function normalizeCampaignCharacterEntries(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return { ...value }
  }

  if (Array.isArray(value)) {
    return value.reduce((acc, entry) => {
      const characterId =
        typeof entry === 'string' || typeof entry === 'number'
          ? String(entry).trim()
          : String(entry?.id || '').trim()

      if (!characterId) return acc

      acc[characterId] =
        entry && typeof entry === 'object' && !Array.isArray(entry)
          ? { id: characterId, ...entry }
          : { id: characterId }
      return acc
    }, {})
  }

  return {}
}

export function isCharacterCampaignPreviewPlaceholder(entry = {}) {
  if (!entry || typeof entry !== 'object') return true

  const rawName = String(entry.name || '').trim()
  const normalizedName = rawName.toLowerCase()
  const avatar = entry.avatar
  const race = String(entry.race || '').trim()
  const classLabel = String(entry.class || '').trim()
  const level = Number(entry.level)

  const isPlaceholderName =
    !rawName || normalizedName === 'campaign character' || normalizedName === 'private character'

  return isPlaceholderName && !avatar && !race && !classLabel && !(level > 0)
}
